module.exports = "<leads-table id=\"leadsRoot\">\n\n</leads-table>";